module.exports = __webpack_public_path__ + "static/media/next.50556c3d.png";